module.exports = __webpack_public_path__ + "img/Sakralbau Fräsmodell.3988120b.jpg";